
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/birth-control-options",
      function () {
        return require("private-next-pages/birth-control-options.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/birth-control-options"])
      });
    }
  